import React, { useEffect, useState } from 'react';
import { PreImg } from 'common/src/components';

interface IProps {
    src: string;
    spareTire?: string;
    children?: JSX.Element;
    onErr?(): void;
    loading?: 'lazy' | 'eager';
}

import './imgSpareTire.scss';

import { spaceLogo } from './util';

export { spaceLogo };

/**
 * @desc 图片加载失败，显示占位图
 * @author Kody
 */
export const ImgSpareTire = (props: IProps) => {
    const { src, spareTire, children, onErr, loading } = props;
    const [isLoadErr, setIsLoadErr] = useState(false);
    const [imgUrl, setImgUrl] = useState(src);

    useEffect(() => {
        setImgUrl(src);
        setIsLoadErr(false);
    }, [src]);

    const onLoadErr = () => {
        if (spareTire) {
            setImgUrl(spareTire);
        }
        setIsLoadErr(true);
        if (onErr) {
            onErr();
        }
    };

    const render = () => {
        if (isLoadErr && children) {
            return children;
        }
        if (isLoadErr && !spareTire) {
            return <div className="spare-tire-frame" />;
        }
        return (
            <PreImg>
                <img
                    src={imgUrl}
                    onError={onLoadErr}
                    className={`spare-tire-frame ${isLoadErr ? 'is-spare' : ''}`}
                    loading={loading}
                />
            </PreImg>
        );
    };
    return render();
};
